import { useFetchData } from "../../../hooks/useFetch";

import { API_SETTINGS_ROUTER, ApiConfig } from "../../../services/api-config";

export interface DriverSettingsPayload {
  time: number
}

export interface DriverSettingsResponse {
  massage: string,
}

export const SettingDriverService = {
    getDeliveryTime: () => {
      const { request, baseResponse, loading } = useFetchData.Get<DriverSettingsResponse>({
        projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
      });
      return {
        fetch: () =>
          request({
            endPoint: API_SETTINGS_ROUTER.API_DETAIL(),
          }),
        response: baseResponse,
        loading: loading,
      }
    },
    settingDeliveryTime: () => {
      const { request, baseResponse, loading } = useFetchData.Post<DriverSettingsResponse>({
        projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
      });
      return {
        fetch: (payload: DriverSettingsPayload) =>
          request({
            endPoint: API_SETTINGS_ROUTER.API_SETTING_DELIVERY_TIME(),
            data: payload,
          }),
        response: baseResponse,
        loading: loading,
      }
    },
    getPickupAcceptTimeout: () => {
      const { request, baseResponse, loading } = useFetchData.Get<DriverSettingsResponse>({
        projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
      });
      return {
        fetch: () =>
          request({
            endPoint: API_SETTINGS_ROUTER.API_DETAIL(),
          }),
        response: baseResponse,
        loading: loading,
      }
    },
    settingPickupAcceptTimeout: () => {
      const { request, baseResponse, loading } = useFetchData.Post<DriverSettingsResponse>({
        projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
      });
      return {
        fetch: (payload: DriverSettingsPayload) =>
          request({
            endPoint: API_SETTINGS_ROUTER.API_SETTING_PICKUP_ACCEPT_TIMEOUT(),
            data: payload,
          }),
        response: baseResponse,
        loading: loading,
      }
    },
    getReminderInterval: () => {
      const { request, baseResponse, loading } = useFetchData.Get<DriverSettingsResponse>({
        projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
      });
      return {
        fetch: () =>
          request({
            endPoint: API_SETTINGS_ROUTER.API_DETAIL(),
          }),
        response: baseResponse,
        loading: loading,
      }
    },
    settingReminderInterval: () => {
      const { request, baseResponse, loading } = useFetchData.Post<DriverSettingsResponse>({
        projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
      });
      return {
        fetch: (payload: DriverSettingsPayload) =>
          request({
            endPoint: API_SETTINGS_ROUTER.API_SETTING_REMINDER_INTERVAL(),
            data: payload,
          }),
        response: baseResponse,
        loading: loading,
      }
    },
};

export default SettingDriverService;
